import { ScriptDescriptionType } from "src/Modules/DynamicForm/Types";
import BaseViewModel from "../../../Models/BaseViewModel";
import { BaseScript } from "../BaseScript";
import Guid from "src/Utils/Guid";

export class EnumTitleScript extends BaseScript {

	path: string | null = null;
	type: string | null = null;

	constructor ( contextElement: BaseViewModel, script: ScriptDescriptionType, scriptPurpose: string ) {
		// 	Вызов конструктора родителя.
		super( contextElement, script, scriptPurpose );

		const matches = this.Content?.match(/^(\w+):\s(.+)/);
		if ( matches && matches.length >= 3 ) {
			this.type = matches[1];
			this.path = matches[2];
		}
	};

	getDependentFields = () => [ this.path ?? "" ];
	
	/** Запустить скрипт в контексте hostObject */
	runScript = () => {
		if ( !this.Content ) return null;
		try {
			window.Guid = Guid;
			window.hostObject = this.hostObject;
			switch ( this.type ) {
				case "EnumTitle": return this.runEnumTitleScript();
				default: throw new Error("Тип специального скрипта '" + this.type + "' не поддерживается");
			}
		} 
		catch ( e: any ) {
			console.warn( e.message );
		}
		return null;
	};

	runEnumTitleScript = () => {
		// TODO
		const viewModel: any = this.contextElement.getViewModelByPath( this.path! );
		if ( !viewModel ) {
			throw new Error( "Не найдена вьюмодель для " + this.path );
		}
		if ( viewModel.selectedValueS2 === null || viewModel.selectedValueS2 === undefined ) return null;
		const value = viewModel.selectedValueS2;
		if ( viewModel.elementDescriptor.DescriptorKey === "EnumControlDescriptor" && viewModel.elementDescriptor.EnumLiterals ) {
			const options = viewModel.elementDescriptor.EnumLiterals;
			for ( let i = 0; i < options.length; i++ ) {
				const option = options[i];
				if ( option.LV === value ) {
					return option.DA;
				}
			}
		} 
		else if ( viewModel.elementDescriptor.DescriptorKey === "DictionaryRegistryControlDescriptor" ) {
			const items = (viewModel.metaData ?? []) as Array<{ id?: unknown; title?: unknown }>;
			const valueStr = typeof value === 'string' ? value : String(value ?? '');
			const normalizeStr = ( s: string ) => s.replace(/["«»]/g, '').replace(/\s+/g, ' ').trim();
			const normalizedValue = normalizeStr(valueStr);

			const exact = items.find( (it) => {
				const idStr = typeof it?.id === 'string' ? it.id : String(it?.id ?? '');
				return idStr === valueStr;
			});
			const normalized = exact ?? items.find( (it) => {
				if ( it?.id == null ) return false;
				const idStr = typeof it.id === 'string' ? it.id : String(it.id);
				return normalizeStr(idStr) === normalizedValue;
			});

			const title = normalized?.title;
			if ( typeof title === 'string' ) return title;
			if ( title == null ) return null;
			return String(title);
		}
		console.groupCollapsed( "EnumTitleScript - enumTitle not found - " + this.path );
		console.log( "viewModel ", viewModel );
		console.log( "value ", value );
		console.groupEnd();
		return null;
	};
};
